import styled from 'styled-components';
import PropTypes from 'prop-types';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

import BackgroundSection from 'components/structure/BackgroundSection';

export const StyledBackgroundSection = styled(BackgroundSection)`
  padding: 3rem 1.5rem;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;

  ${tablet768`
    padding: 2.5rem;
    display: flex;
    justify-content: flex-end;
  `}

  ${desktop1024`
    padding: 5.75rem 10rem;
  `}
`;

StyledBackgroundSection.displayName = 'StyledBackgroundSection';

export const Content = styled.div`
  padding: 1.5rem;
  margin-top: 16rem;
  background-color: ${nuDSColor('white')};

  ${tablet768`
    ${props => props.hasHeadline && 'margin-top: 5rem;'}
    width: 24.25rem;
    padding: 2rem;
    align-self: flex-end;
  `}
`;

Content.propTypes = {
  hasHeadline: PropTypes.bool.isRequired,
};

Content.displayName = 'Content';

export const Headline = styled.div`
  text-align: center;

  ${tablet768`
    text-align: left;
    width:  30rem;
  `}
`;

Headline.displayName = 'Headline';
